// extracted by css-extract-rspack-plugin
export default {"parameter":"lnsju","selected":"qZ8sw","noPopover":"QJ9jA","DashboardNight":"afuoO","name":"dZ0BH Iup3O","widgetStatus":"qdMf6"};